import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` This article only applies to users of the public npm registry.`}</p>
    </Note>
    <p>{`As an organization owner, you can upgrade your free organization plan to the npm Teams product.  npm Teams is a paid plan to give organization members the ability to install and publish private packages.  For more information about npm Teams and our organization pricing plans, see the "npm Teams" section of `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/pricing"
      }}>{`our pricing page`}</a>{`.`}</p>
    <p>{`If you have an organization with a private packages plan, your organization will cost you seven (7) dollars a month per user. `}<strong parentName="p">{`The $7 charge is a flat fee for any member of the organization even if the teams the member belongs do not have access to private packages`}</strong></p>
    <p>{`Newly added members to an organization are always billed during the next billing cycle. For more information, see "`}<a parentName="p" {...{
        "href": "adding-members-to-your-org"
      }}>{`Adding members to your organization`}</a>{`".`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` Your paid plan and billing cycle will start when you submit your credit card information, and you will be charged for the first month immediately.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left sidebar, click the name of the organization you want to upgrade.`}</p>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-billing-tab'].text}</>
        <>{shared['organization-billing-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "change plan", click `}<strong parentName="p">{`Upgrade Plan ($7/User)`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "Want to upgrade?", click `}<strong parentName="p">{`Enable Private Publishing for $7/mo`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <>{shared['billing-form'].text}</>
        <>{shared['billing-form'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['payment-info-button'].text}</>
        <>{shared['payment-info-button'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-creditcard-form'].text}</>
        <>{shared['billing-creditcard-form'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['payment-remember-me'].text}</>
        <>{shared['payment-remember-me'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Pay`}</strong>{` for the monthly amount.  The monthly amount will be the number of members in your organization multiplied by $7.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      